<template>
  <div
    :class="DS_FORM_FIELD_ERROR_CLASSES.Root"
    data-cy="ds-form-field-error"
    data-ds-error
  >
    <DSIcon
      :class="DS_FORM_FIELD_ERROR_CLASSES.Icon"
      icon="warning"
      appearance="filled"
      size="md"
      aria-hidden="true"
    />
    <span>{{ props.errorMessage }}</span>
  </div>
</template>

<script setup lang="ts">
import DSIcon from "@/src/design_system/primitives/icon/components/DSIcon.vue";
import { DS_FORM_FIELD_ERROR_CLASSES } from "../constants/classes";
import type { DSFormFieldErrorProps } from "../types";

const props = defineProps<DSFormFieldErrorProps>();
</script>
